import api from "@/lib/api";

/**
 * Heads-up display + score popup for the Daily Challenge.
 * Two thin components co-located because they share styling.
 */
export function ChallengeHud({ activeChallenge, onFinished }) {
  if (!activeChallenge) return null;
  return (
    <div data-testid="challenge-hud" className="bg-gradient-to-r from-amber-500/10 to-rose-500/10 border-y border-amber-500/30 px-4 py-2 flex items-center justify-between gap-4 text-xs font-mono">
      <div className="flex items-center gap-3">
        <i className="fa-solid fa-bolt text-amber-300 animate-pulse"/>
        <span className="text-amber-200 font-bold uppercase">Challenge Active</span>
        <span className="text-slate-400 text-[10px]">Seed: {(activeChallenge.session_start_utc || "").slice(0,16).replace("T"," ")} UTC</span>
      </div>
      <div className="flex items-center gap-3">
        <div className="text-slate-300">Trades: <span className="text-white font-bold">{(activeChallenge.trade_ids || []).length}/{activeChallenge.max_trades}</span></div>
        <div className="text-slate-300">Bankroll cap: <span className="text-emerald-300 font-bold">${activeChallenge.starting_capital}</span></div>
        <button
          data-testid="challenge-end-now"
          onClick={async () => {
            if (!window.confirm("End the challenge now and score remaining trades?")) return;
            try {
              const { data } = await api.post(`/challenges/${activeChallenge.id}/finish`);
              onFinished({ score: data?.score, trades: data?.trades });
            } catch {}
          }}
          className="px-2 py-1 bg-rose-600/30 hover:bg-rose-600/50 border border-rose-500/50 text-rose-200 rounded text-[10px] font-bold">
          <i className="fa-solid fa-flag-checkered mr-1"/> END NOW
        </button>
      </div>
    </div>
  );
}

export function ChallengeScoreModal({ challengeScore, onClose }) {
  if (!challengeScore) return null;
  return (
    <div data-testid="challenge-score-modal" className="fixed inset-0 bg-black/80 backdrop-blur-md z-50 flex items-center justify-center p-4 font-mono" onClick={onClose}>
      <div className="bg-[#0f131b] border border-amber-500/40 rounded-2xl max-w-md w-full p-6 shadow-2xl" onClick={e => e.stopPropagation()}>
        <div className="text-center mb-4">
          <i className="fa-solid fa-trophy text-5xl text-amber-300 mb-3"/>
          <h2 className="text-xl font-bold text-white">Challenge Complete</h2>
          <p className="text-[11px] text-slate-500 mt-1">{challengeScore.trades || 0} trade(s) scored by AI</p>
        </div>
        <div className="bg-gradient-to-r from-amber-500/20 to-rose-500/20 border border-amber-500/40 rounded-xl p-4 text-center mb-3">
          <div className="text-[10px] uppercase tracking-widest text-amber-300">Final Score</div>
          <div className="text-5xl font-black text-amber-200 tabular-nums">{challengeScore.score?.total ?? 0}</div>
          <div className="text-[10px] text-slate-500">/ 100 pts</div>
        </div>
        <button onClick={onClose} data-testid="challenge-score-close"
          className="w-full py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-xs font-bold">Continue</button>
      </div>
    </div>
  );
}
